goog.provide("shadow.js.shim.module$$jupyterlab$notebook");
goog.provide("module$shadow_js_shim_module$$jupyterlab$notebook");
shadow.js.shim.module$$jupyterlab$notebook = require("@jupyterlab/notebook");
module$shadow_js_shim_module$$jupyterlab$notebook.default = shadow.js.shim.module$$jupyterlab$notebook;
